class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
    let width = window.innerWidth;
    if (window.innerWidth < 1024) {    
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        window.location.href = window.routes.cart_url
      });    
    } else {      
      // const cartDrawer = document.querySelector('cart-drawer');
      // let myTimeout;
      // cartLink.addEventListener("mouseover", (event) => {
      //   event.preventDefault();
      //   clearTimeout(myTimeout);
      //   cartDrawer.classList.add('animate', 'active');
      // });
      // cartLink.addEventListener("mouseleave", (event) => {
      //   myTimeout = setTimeout(function(){
      //     cartDrawer.classList.remove('animate', 'active');
      //   }, 200); 
      // });
      // cartDrawer.addEventListener("mouseover", (event) => {
      //   clearTimeout(myTimeout);
      //   cartDrawer.classList.add('animate', 'active');
      //   cartDrawer.addEventListener("mouseleave", () => {
      //     cartDrawer.classList.remove('animate', 'active');
      //   });
      // });
    }
  }
  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // // here the animation doesn't seem to always get triggered. A timeout seem to help
    // setTimeout(() => {
    //   this.classList.add('animate', 'active');
    // });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }
     updateDrawer(openCartDrawer = true) {
      const sections = this.getSectionsToRender().map(s => s.id);

      fetch(`${routes.cart_url}?sections=${sections.join(",")}`)
        .then(res => res.json())
        .then(sectionsHTML => {
          const parsedState = {
            sections: sectionsHTML
          };

          this.renderContents(parsedState, openCartDrawer);
        })
        .catch(err => {
          console.error("Cart drawer update failed:", err);
        });
    }


  renderContents(parsedState, openCartDrawer = true) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    if(parsedState.id) this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      if (openCartDrawer) {
        this.open();
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);


class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

document.addEventListener('DOMContentLoaded', () => {
  const cartIcon = document.querySelector('#cart-icon-bubble');
  
  function initDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');

    if (!cartIcon || !cartDrawer) {
      console.log('Still missing:', { cartIcon, cartDrawer });
      return;
    }

    // cartIcon.addEventListener('mouseenter', () => {
    //   cartDrawer.classList.add('active', 'animate');
    // });

    // cartIcon.addEventListener('mouseleave', () => {
    //   setTimeout(() => {
    //     if (!cartDrawer.matches(':hover')) {
    //       cartDrawer.classList.remove('active', 'animate');
    //     }
    //   }, 100);
    // });

    // cartDrawer.addEventListener('mouseleave', () => {
    //   cartDrawer.classList.remove('active', 'animate');
    // });
  }

  // Retry until Shopify loads it
  const interval = setInterval(() => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      clearInterval(interval);
      initDrawer();
    }
  }, 600);
});